import Heading from "atoms/Heading";
import Text from "atoms/Text";
import { Check } from "react-feather";
import DialogBox from "@/molecules/DialogBox";

const MatchSuccessfulDialog = ({ data, close }) => {

    const InfoRow = ({ label, value, valueClass = "", rightContent }) => {
        return (
            <div className="flex py-1 px-2 border-b border-gray-500">
                <p className="text-gray-200 min-w-32 text-[10px]">{label}</p>

                {rightContent ? (
                    rightContent
                ) : (
                    <span className={`text-gray-100 text-xs font-medium ${valueClass}`}>
                        {value}
                    </span>
                )}
            </div>
        );
    };
    return (
        <DialogBox
            customPadding="p-8"
            bgColor='bg-gray-800 border border-gray-500'
            width="w-[450px]">
            <div>

                <div className="flex items-center justify-between pb-6 border-b border-gray-500 mb-6">
                    <div className="flex items-center gap-2">
                        <Check strokeWidth={3} size={22} className="text-success-300 border-2 border-success-300 rounded-full p-[3px]" />
                        <Heading type="h6" className="font-semibold text-success-300">MATCH SUCCESSFULL</Heading>
                    </div>

                    <div className="flex items-center gap-2">
                        <Text variant='caption' className='text-gray-200'>{data.n}</Text>
                        <Text variant='caption' fontWeight='font-semibold' className='text-gray-200 border border-gray-500 px-1.5 py-0.5 rounded-sm'>{data.s}</Text>
                    </div>
                </div>

                <div className="w-full">

                    <div className="bg-gray-900 rounded-md p-3 flex flex-col items-center gap-2 justify-center mb-4">
                        <div className="flex items-end gap-1">
                            <Heading type="h1" className="font-semibold text-success-300">{data.q}</Heading>
                            <Text variant='caption' fontWeight='font-medium' className='text-gray-200'>K</Text>
                        </div>

                        <div className="border border-primary-100/25 bg-primary-110 flex items-center gap-1 px-3.5 h-6 rounded-md">
                            <div className="w-1.5 h-1.5 rounded bg-primary-100" />
                            <Text variant='caption' fontWeight='font-medium' className={`text-primary-100`}>{data.type}</Text>
                        </div>
                        <Text variant='bodySmall' className={`text-gray-300`}> Matched in this session.</Text>

                    </div>

                    {/* DETAILS */}
                    <div className="text-sm">

                        <InfoRow label="CURVE" value={data.n} />

                        <InfoRow label="STRUCTURE" value={data.s} />

                        <InfoRow
                            label="PRICE"
                            value={data.p}
                            valueClass="text-success-300"
                        />

                        <InfoRow
                            label="SIZE"
                            rightContent={
                                <div className="flex items-center justify-between text-xs font-medium gap-2 w-full">
                                    <p className="text-gray-100">{data.q}K</p>
                                    <p className="text-[10px] px-2 py-0 bg-success-300/10 text-success-300 border border-success-300/25 rounded-sm font-semibold">
                                        FILLED
                                    </p>
                                </div>
                            }
                        />
                    </div>
                </div>

                <button className="w-full mt-6 bg-success-300 text-gray-100 h-11 rounded-md text-base font-semibold active:scale-95"
                    onClick={close}>
                    OK
                </button>

            </div>
        </DialogBox>
    );
};

export default MatchSuccessfulDialog;